import React from "react";
import AppConfig from "util/AppConfig";
import { Badge } from "components/bootstrap";
import InactiveNavItem from "components/navigation/InactiveNavItem";
const DevelopmentHeaderBadge = () => AppConfig.gl2DevMode() ? /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(InactiveNavItem, null, /* @__PURE__ */ React.createElement(Badge, { className: "dev-badge", bsStyle: "danger" }, AppConfig.isCloud() ? String.fromCharCode(9928) : "", " DEV"))) : null;
export default DevelopmentHeaderBadge;
